import { render } from "./ClientSecretsManager.vue?vue&type=template&id=60542e1a&scoped=true"
import script from "./ClientSecretsManager.vue?vue&type=script&lang=js"
export * from "./ClientSecretsManager.vue?vue&type=script&lang=js"

import "./ClientSecretsManager.vue?vue&type=style&index=0&id=60542e1a&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-60542e1a"]])

export default __exports__